import { FlashPromotion } from "~/entities/flashPromotionEntities";
import Client from "../baseClient";
import { getSubdomainFromRequest } from "~/helpers/requestHelpers";

export const FlashPromotionApi = {
  /**
   * The flash promotion for this site and order type, or null. Targeting,
   * scheduling and the liveness check are all applied server side, so anything
   * returned here is safe to show.
   *
   * `requestedReadyTime` matters: the engine validates codes against the order's
   * requested ready time rather than now, so a 2pm order for 7pm collection
   * needs the 7pm answer. Omitting it falls back to now, which is right for ASAP.
   */
  getFlashPromotion: async (
    request: Request,
    siteId: string,
    orderTypeCode: string,
    requestedReadyTime: string | null,
  ) => {
    const params = new URLSearchParams({ orderTypeCode });
    if (requestedReadyTime) {
      params.set("requestedReadyTime", requestedReadyTime);
    }

    return await Client.get<FlashPromotion | null>(
      `org/${getSubdomainFromRequest(
        request,
      )}/sites/${siteId}/flash-promotions?${params.toString()}`,
    );
  },
};
